import React, { createContext, useContext, useState, useEffect } from 'react';

const SiteContentCtx = createContext({});

export function SiteContentProvider({ children }) {
  const [content, setContent] = useState({});
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    fetch(`/api/site-content`)
      .then(r => r.json())
      .then(data => { setContent(data); setLoaded(true); })
      .catch(() => setLoaded(true));
  }, []);

  return <SiteContentCtx.Provider value={{ content, loaded }}>{children}</SiteContentCtx.Provider>;
}

export function useSiteContent(key, fallback) {
  const { content } = useContext(SiteContentCtx);
  return content[key] || fallback || {};
}
